import * as React from 'react';
import { getBreadcrumbs } from '../../selectors/seo/getBreadcrumbs';
import { useSelector } from 'react-redux';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SIZE_16, SIZE_20 } from '../../constants/sizes';
import { Container } from '../../components/Container';

export const BreadcrumbsContainer = () => {
  const breadcrumbs = useSelector(getBreadcrumbs);

  return (
    <Container dataMark="QuickLinksComponent" padding={`${SIZE_16} 0 ${SIZE_20}`} noPrint>
      <Breadcrumbs stack={breadcrumbs} />
    </Container>
  );
};
